export const toIsoDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`

export const sameYMD = (dateA, dateB) =>
  dateA.getFullYear() === dateB.getFullYear() &&
  dateA.getMonth() === dateB.getMonth() &&
  dateA.getDate() === dateB.getDate()

export const clamp = (value, min, max) =>
  Math.max(min, Math.min(max, value))

export const parseHM = (timeString) => {
  const [hourRaw, minuteRaw] = (timeString || '').split(':').map(x => parseInt(x, 10))
  return {
    hour: Number.isNaN(hourRaw) ? 0 : hourRaw,
    minute: Number.isNaN(minuteRaw) ? 0 : minuteRaw,
  }
}

export const buildHourOptions = ({ startHour, endHour, isToday, now }) => {
  let fromHour = startHour
  let toHour = endHour

  if (isToday) {
    fromHour = Math.max(startHour, now.getHours())
  }

  fromHour = clamp(fromHour, 0, 23)
  toHour = clamp(toHour, 0, 23)

  const options = []
  for (let hour = fromHour; hour <= toHour; hour++) {
    options.push({ id: String(hour), label: String(hour).padStart(2, '0') })
  }
  return options
}

export const buildMinuteOptions = ({ currentHour, startHour, startMinute, isToday, now, minuteStep }) => {
  let fromMinute = 0

  if (isToday && String(currentHour) === String(now.getHours())) {
    const nextStep = Math.ceil(now.getMinutes() / minuteStep) * minuteStep
    fromMinute = Math.min(50, nextStep)
  } else if (String(currentHour) === String(startHour)) {
    fromMinute = startMinute
  }

  const options = []
  for (let minute = fromMinute; minute < 60; minute += minuteStep) {
    options.push({ id: String(minute), label: String(minute).padStart(2, '0') })
  }

  return options.length ? options : [{ id: '0', label: '00' }]
}
